import * as React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

import { mediaQueryDown } from 'components/utils/breakpoint'
import BodyText from 'LuxKit/Typography/BodyText'
import QuoteClosedIcon from 'LuxKit/Icons/custom/QuoteClosedIcon'
import QuoteOpenedIcon from 'LuxKit/Icons/custom/QuoteOpenedIcon'

const Root = styled.div`
  position: relative;
  width: 80%;
  padding-right: ${rem(40)};
  padding-left: ${rem(40)};

  & + & {
    margin-top: ${rem(25)};
  }

  ${mediaQueryDown.tablet} {
    width: 100%;
  }
`

const PositionedQuoteOpen = styled(QuoteOpenedIcon)`
  position: absolute;
  left: 0;
`

const Source = styled(BodyText)`
  margin-top: ${rem(5)};
`

const PositionedQuoteClose = styled(QuoteClosedIcon)`
  position: absolute;
  right: 0;
  bottom: ${rem(8)};
  margin-right: ${rem(40)};
`

interface Props {
  content?: string
  source?: string
}

function PropertyReview(props: React.PropsWithChildren<Props>) {
  const {
    content,
    source,
  } = props
  const intl = useIntl()

  return (
    <Root>
      <PositionedQuoteOpen colour="primary" />
      <BodyText variant="medium">{content}</BodyText>
      <Source variant="medium" weight="bold">{intl.formatMessage({
        id: 'cv9aTL6R-unHLUKqwCJ0',
        defaultMessage: '- {source}',
        description: 'Review source attribution with dash prefix in the reviews section',
      }, { source })}
      </Source>
      <PositionedQuoteClose colour="primary" />
    </Root>
  )
}

export default PropertyReview
